// client/src/components/Footer.js

import React, { useEffect, useState } from 'react';
import axios from 'axios';
import {
  FaFacebookF,
  FaTwitter,
  FaInstagram,
  FaLinkedinIn
} from 'react-icons/fa';

export default function Footer() {
  // We'll fetch the same `homeConfig` to get the "footer" logo
  const [footerLogo, setFooterLogo] = useState('/assets/images/ariel-logo.png');

  useEffect(() => {
    axios
      .get(`${process.env.REACT_APP_API_URL}/api/home-config`)
      .then(res => {
        if (res.data.logo) {
          setFooterLogo(`${process.env.REACT_APP_API_URL}/${res.data.logo}`);
        }
      })
      .catch(err => console.error('Error fetching homeConfig for footer:', err));
  }, []);

  return (
    <footer className="bg-primaryGreen text-white pt-10 pb-6 mt-0">
      {/* 3 columns: Logo, Quick Links, Follow Us */}
      <div className="max-w-7xl mx-auto px-4 grid grid-cols-1 md:grid-cols-3 gap-8">
        
        {/* 1) Logo Only */}
        <div className="flex flex-col items-start">
          <img
            src={footerLogo}
            alt="Footer Logo"
            className="h-24 w-auto mb-4"
          />
          {/* (Removed the paragraph text that was under the logo) */}
        </div>

        {/* 2) Quick Links */}
        <div>
          <h4 className="text-xl font-semibold mb-4">Quick Links</h4>
          <ul className="space-y-2 text-sm">
            <li>
              <a href="/shop" className="hover:text-gray-200 text-white transition">
                Our Products
              </a>
            </li>
            <li>
              <a href="/about" className="hover:text-gray-200 text-white transition">
                About Us
              </a>
            </li>
            <li>
              <a href="/contact" className="hover:text-gray-200 text-white transition">
                Contact
              </a>
            </li>
            <li>
              <a href="/license" className="hover:text-gray-200 text-white transition">
                License
              </a>
            </li>
            <li>
              <a href="/financing" className="hover:text-gray-200 text-white transition">
                Financing
              </a>
            </li>
            <li>
              <a href="/faq" className="hover:text-gray-200 text-white transition">
                FAQ
              </a>
            </li>
          </ul>
        </div>

        {/* 3) Follow Us */}
        <div>
          <h4 className="text-xl font-semibold mb-4">Follow Us</h4>
          <div className="flex space-x-4">
            <a
              href="https://facebook.com"
              className="text-white hover:text-gray-200 transition"
            >
              <FaFacebookF size={20} />
            </a>
            <a
              href="https://twitter.com"
              className="text-white hover:text-gray-200 transition"
            >
              <FaTwitter size={20} />
            </a>
            <a
              href="https://instagram.com"
              className="text-white hover:text-gray-200 transition"
            >
              <FaInstagram size={20} />
            </a>
            <a
              href="https://linkedin.com"
              className="text-white hover:text-gray-200 transition"
            >
              <FaLinkedinIn size={20} />
            </a>
          </div>
        </div>
      </div>

      <div className="mt-8 border-t border-white pt-4 text-center text-sm text-white">
        &copy; {new Date().getFullYear()} Aerial Spray Solutions. All rights reserved.
      </div>
    </footer>
  );
}
